module.exports = __webpack_public_path__ + "static/media/dislike-hover-button.bddeb33a.svg";